module.exports = __webpack_public_path__ + "static/media/vermi_nursery.cae0a9c1.png";